module.exports = __webpack_public_path__ + "static/largetile-d2fa7eba399528d3188f31954e5754b2.png";